import { AcknowledgementTypes, SuggestedPrompt, SuggestedPromptsResponse, UserAcknowledgementResponse } from '../models/chat';
import { API } from '../shared/constants';
import { AiInsightsBaseAdapter } from './ai-insights-base-adapter';
import { HttpConnectorAdapter } from './http-connector-adapter';



let singletonInstance: AiInsightsAdapter;
export class AiInsightsAdapter implements AiInsightsBaseAdapter {
    static getAdapter(): AiInsightsBaseAdapter {
        if (!singletonInstance) {
            singletonInstance = new AiInsightsAdapter();
        }

        return singletonInstance;
    }

    async sendAcknowledgeAccess(userId: string, type: AcknowledgementTypes): Promise<{message: string, acknowledge: boolean}> {
        const {
            USERS: { ACKNOWLEDGE },
            Tokens: { USERS: { USER_ID } }
        } = API.URL;
        const response = await HttpConnectorAdapter
            .post(
                ACKNOWLEDGE.replace(USER_ID, userId), { type, acknowledge: true }
            );
        const {
            status,
            message,
            data: userData
        }: UserAcknowledgementResponse = response.data;
        if (!status || !userData) {
            return Promise.reject();
        }

        return {message, acknowledge: userData?.acknowledge ? userData.acknowledge : false};
    }

    async getAcknowledgementStatus(userId: string, type: AcknowledgementTypes): Promise<boolean> {
        const {
            USERS: { ACKNOWLEDGE },
            Tokens: { USERS: { USER_ID } }
        } = API.URL;

        const url = ACKNOWLEDGE.replace(USER_ID, userId);
        const response = await HttpConnectorAdapter
            .get(`${url}/${type}`);
        const {
            status,
            data: userData
        }: UserAcknowledgementResponse = response.data;
        if (!status || !userData) {
            return Promise.reject();
        }

        return userData?.acknowledge ? userData.acknowledge : false;
    }

    async getSuggestedPrompts(teamId: string): Promise<SuggestedPrompt[]> {
        const {
            AI_INIGHTS: { SUGGESTED_PROMPTS }
        } = API.URL;

        const response = await HttpConnectorAdapter.get(SUGGESTED_PROMPTS, {}, { teamId });
        const {
            status,
            data: suggestedPrompts
        }: SuggestedPromptsResponse = response.data;

        if (!status || !suggestedPrompts) {
            return Promise.reject();
        }

        return suggestedPrompts?.suggested_prompts ? suggestedPrompts.suggested_prompts : [];
    }
}
